import { createContext, ReactNode, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { NavItem } from '@components/layout/src/layout.types';
import { NavigationContextValue } from '@contexts/navigation/navigation.type';
import { useMainSidebarMenu } from '@hooks/use-main-sidebar-menu';

export const NavigationContext = createContext<NavigationContextValue>({
  navigationItems: [],
  isItemClicked: false,
  setNavigation: () => {},
  setIsItemClicked: () => {},
  preventRedirect: false,
  setPreventRedirect: () => {},
  redirectUrl: '',
  setRedirectUrl: () => {},
  route: {
    from: '',
    to: '',
  },
});

export const NavigationProvider = ({ children }: { children: ReactNode }) => {
  const [navigationItems, setNavigationItems] = useState<NavItem[]>([]);
  const [isItemClicked, setIsItemClicked] = useState<boolean>(false);
  const [preventRedirect, setPreventRedirect] = useState<boolean>(false);
  const [redirectUrl, setRedirectUrl] = useState<string>('');
  const location = useLocation();
  const sidebarMenu = useMainSidebarMenu();

  const [route, setRoute] = useState({
    to: location.pathname,
    from: location.pathname,
  });

  useEffect(() => {
    if (location.pathname !== route.to) {
      setRoute((prev) => ({ to: location.pathname, from: prev.to }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    setNavigationItems(sidebarMenu ?? []);
  }, [sidebarMenu]);

  const contextValue = useMemo(
    () => ({
      navigationItems,
      isItemClicked,
      preventRedirect,
      redirectUrl,
      route,
      setNavigation: setNavigationItems,
      setIsItemClicked,
      setPreventRedirect,
      setRedirectUrl,
    }),
    [navigationItems, isItemClicked, preventRedirect, redirectUrl, route]
  );

  return <NavigationContext.Provider value={contextValue}>{children}</NavigationContext.Provider>;
};
